import {
  CheckBoxOutlined,
  IndeterminateCheckBoxOutlined,
} from "@mui/icons-material";
import { Checkbox, CheckboxProps } from "@mui/material";

export function CheckboxOutlined(props: CheckboxProps) {
  return (
    <Checkbox
      {...props}
      checkedIcon={<CheckBoxOutlined />}
      indeterminateIcon={<IndeterminateCheckBoxOutlined />}
    />
  );
}
